import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import HomePage from './pages/HomePage';
import RecipesPage from './pages/RecipesPage';
import RecipeDetailPage from './pages/RecipeDetailPage';
import AddRecipePage from './pages/AddRecipePage';
import ImportRecipesPage from './pages/ImportRecipesPage';
import BudgetPage from './pages/BudgetPage';
import ContestPage from './pages/ContestPage';
import ContactPage from './pages/ContactPage';
import theme from './styles/theme';
import GlobalStyles from './styles/GlobalStyles';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatAssistant from './components/ChatAssistant';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/recipes" element={<RecipesPage />} />
              <Route path="/recipes/:id" element={<RecipeDetailPage />} />
              <Route path="/budget" element={<BudgetPage />} />
              <Route path="/concours" element={<ContestPage />} />
              <Route path="/add-recipe" element={<AddRecipePage />} />
              <Route path="/import-recipes" element={<ImportRecipesPage />} />
              <Route path="/categories" element={<RecipesPage />} />
              <Route path="/occasions" element={<RecipesPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </main>
          <Footer />
          <ChatAssistant />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
